// extracted by mini-css-extract-plugin
module.exports = {"sectitel":"earn-share-points_sectitel__1qOWj","ernpoints":"earn-share-points_ernpoints__BeH2R","wrapper":"earn-share-points_wrapper__2-kLS"};